import { FastFilters } from '../fast_filters';
import { appendPreloader } from '../preloader';

export function init(fastFilters: FastFilters) {
  const button = document.querySelector('[data-mark=dealType]') as HTMLButtonElement;

  if (!button) {
    return () => [];
  }

  let removeLoader: (() => void) | undefined;

  const clickListener = (e: MouseEvent) => {
    fastFilters.scheduleClick('dealType', () => {
      if (removeLoader) {
        removeLoader();
        removeLoader = undefined;
      }
    });
    removeLoader = appendPreloader(button, {
      size: 15,
      style: 'position:relative;top:2px;margin-left:8px;',
    });
  };

  button.addEventListener('click', clickListener);

  return () => {
    button.removeEventListener('click', clickListener);
  };
}
